import { useAutocompleteSource } from '@eas/common-web';
import { DictEducationFieldAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useEducationFields() {
  return useAutocompleteSource<DictEducationFieldAutocomplete>({
    url: `${EvidenceApiUrl.DICT_EDUCATION_FIELD}/autocomplete`,
  });
}
